import { render, staticRenderFns } from "./updateRegisAmount.vue?vue&type=template&id=688c50bd&"
import script from "./updateRegisAmount.vue?vue&type=script&lang=js&"
export * from "./updateRegisAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports